import baseAPI from "@/http";

const router = "api/pergunta/perguntamunicipio";

export const cityQuestionAPI = {
  getAtendentesProdutividade: (municipioId) =>
    baseAPI.get(`${router}/get-atendentes-produtividade/${municipioId}`),
  put: (pergunta) => baseAPI.put(`${router}`, pergunta),
  getRespondidas: (id) =>
    baseAPI.get(`${router}/get-perguntas-municipios-respondidas/${id}`),
  getEvidenciadas: (id) =>
    baseAPI.get(`${router}/get-perguntas-municipios-evidenciadas/${id}`),
  getAprovadas: (id) =>
    baseAPI.get(`${router}/get-perguntas-municipios-aprovadas/${id}`),
  getRejeitadas: (id) =>
    baseAPI.get(`${router}/get-perguntas-municipios-rejeitadas/${id}`),
  getPergunta: (perguntaId) =>
    baseAPI.get(`${router}/get-pergunta/${perguntaId}`),
  getPerguntaByPerguntaId: (
    municipioId,
    perguntaId,
    uf = null,
    parceiro = false,
    ambiente = "prod"
  ) =>
    baseAPI.get(
      `${router}/get-pergunta-by-perguntaid/${municipioId}/${perguntaId}`,
      {
        params: {
          ...(uf && { uf }),
          parceiro,
          ambiente,
        },
      }
    ),

  salvarEvidencias: (evidencia) =>
    baseAPI.post(`${router}` + "/salvarevidencias", evidencia),
  preAnaliseUpload: (evidencia) =>
    baseAPI.post(`${router}` + "/pre-analise-upload", evidencia),
  getPerguntas: (municipioId) =>
    baseAPI.get(`${router}/get-perguntas/${municipioId}`),
  getPDFPerguntas: (filtro) =>
    baseAPI.post(`${router}/get-pdf-perguntas`, filtro, {
      responseType: "blob",
    }),
  getPDFPerguntasTema: (temaId) =>
    baseAPI.get(`${router}/get-pdf-perguntas-by-tema/${temaId}`, {
      responseType: "blob",
    }),
  atualizarPergunta: (perguntaId) =>
    baseAPI.put(
      `${router}` + "/atualizar-pergunta-municipio-evidencia/" + perguntaId
    ),
  revertarAnalise: (perguntaMunicipioId) =>
    baseAPI.put(`${router}` + "/reverter-analise/" + perguntaMunicipioId),
  revertarEnvio: (perguntaMunicipioId) =>
    baseAPI.put(`${router}` + "/reverter-envio/" + perguntaMunicipioId),
  desbloquearDataLimiteEnvio: (
    perguntaMunicipioId,
    municipioId,
    dataEnvioLimite
  ) =>
    baseAPI.put(`${router}/desbloquear-data-limite-envio`, null, {
      params: {
        perguntaMunicipioId,
        municipioId,
        DataEnvioLimite: dataEnvioLimite,
      },
    }),
  desbloquearDataLimiteEnvioDeclaracao: (
    perguntaMunicipioId,
    municipioId,
    dataEnvioLimiteDeclaracao
  ) =>
    baseAPI.put(`${router}/desbloquear-data-limite-envio-declaracao`, null, {
      params: {
        perguntaMunicipioId,
        municipioId,
        DataEnvioLimiteDeclaracao: dataEnvioLimiteDeclaracao,
      },
    }),
};
